// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inventoryForm[data-v-0e2edd7c] .avue-crud__menu{display:none}.inventoryForm[data-v-0e2edd7c] .el-drawer__header{margin-bottom:0}.inventoryForm[data-v-0e2edd7c] .el-drawer__body{padding-top:0}.inventoryForm[data-v-0e2edd7c] .avue-crud__search .avue-form{padding:0}.inventoryForm[data-v-0e2edd7c] .el-select{display:inline-block;position:relative;width:100%}", ""]);
// Exports
module.exports = exports;
